import React, { useEffect, useState, useContext } from "react";
import { PlusOutlined, FileImageOutlined  } from "@ant-design/icons";
import {
  Button,
  Tabs,
  Typography,
  Input,
  message,
  Spin,
  Popconfirm,
  Select,
  List,
  Table,
  Space,
  Tree,
  Row,
  Col,
} from "antd"; // Import Select and List
import { Link, useNavigate, useParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import AddActivity from "../Modals/AddActivity";
import Activity from "../components/Activity";
import UpdateTask from "../Modals/UpdateTask";
import AuthContext from "../context/authContext";
import axios from "axios";
import {unloadUnityWebGL, unityContext} from "../context/unityContext";

const { Title, Text } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;
const { Column } = Table;

const Klasse = () => {
  const { id } = useParams(); // Get class ID from URL
  const navigate = useNavigate();
  const [classItem, setClassItem] = useState(null);
  const [loading, setLoading] = useState(true); // Loading state
  const [users, setUsers] = useState([]); // List of all users
  const [existingMembers, setExistingMembers] = useState([]); // Existing members of the group
  const [selectedUser, setSelectedUser] = useState(null); // Selected user to add

  const [stories, setStories] = useState([]); // List of stories
  const [selectedStory, setSelectedStory] = useState(null); // Chosen story
  const [characters, setCharacters] = useState([]); // Characters of selected story
  const [members, setMembers] = useState([]); // Group members
  const [assignments, setAssignments] = useState({}); // Character -> Member mapping
  const [allAssignments, setAllAssignments] = useState({});
  const [activities, setActivities] = useState([]);
  const [selectedGroupMembers, setSelectedGroupMembers] = useState([]);
  const [selectedGroupActivityId, setSelectedGroupActivityId] = useState(null);
  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [selectedGroupName, setSelectedGroupName] = useState("");
  const [activeActivityId, setActiveActivityId] = useState(null);

  const [showTaskForm, setShowTaskForm] = useState(false);
  const [isUpdateModalVisible, setIsUpdateModalVisible] = useState(false);
  const [taskToEdit, setTaskToEdit] = useState(null);

  const { currentUser } = useContext(AuthContext);
  const [isOwner, setIsOwner] = useState(false);
  const classMemberCount = Number(classItem?.member_count || 0);

  useEffect(() => {

    if (unityContext) unloadUnityWebGL();
    const fetchClasses = async () => {
      
      try {
        let response;
        if (currentUser.role === 0) {
          setIsOwner(true);
        } else {
          // Normal users fetch classes they belong to
          console.log("normal user get class!!");
        }
      } catch (error) {
        console.error("Error fetching classes:", error);
        message.error("Beim Abrufen der Klassen ist ein Fehler aufgetreten.");
      }
    };
    fetchClasses();
  }, [currentUser.id, currentUser.role]);

  useEffect(() => {
    // Fetch all stories when component loads
    axios.get("/api/stories").then((res) => setStories(res.data));
  }, []);

  useEffect(() => {
    if (selectedStory) {
      // Fetch characters for the selected story
      axios
        .get(`/api/characters/?storycharid=${selectedStory}`)
        .then((response) => {
          setCharacters(response.data);
        })
        .catch((error) => {
          console.error("Error fetching characters:", error);
        });

      // ✅ Fetch assigned tasks for the selected story
      axios
        .get(`/api/tasks/${selectedStory}/tasks`)
        .then((res) => {
          console.log("Fetched tasks:", res.data);
          const tasks = res.data;
          const formattedTasks = {};

          // Format tasks based on the new structure
          tasks.forEach((task) => {
            // If the task has an associated character
            if (task.characterId) {
              if (!formattedTasks[task.characterId]) {
                formattedTasks[task.characterId] = {
                  id: task.id,
                  member: task.member_id,
                  task: task.category,
                  description: task.description,
                  characterId: task.characterId, // Include characterId for reference
                };
              }
            } else {
              // Handle tasks without characters (if applicable)
              if (!formattedTasks["noCharacter"]) {
                formattedTasks["noCharacter"] = [];
              }
              formattedTasks["noCharacter"].push({
                id: task.id,
                member: task.member_id,
                task: task.category,
                description: task.description,
              });
            }
          });
          console.log("formattedTasks:", formattedTasks);
          setAssignments(formattedTasks);
        })
        .catch((error) => console.error("Error fetching tasks:", error));
    }
  }, [selectedStory]); // Runs when selectedStory changes

  useEffect(() => {
    console.log(">>>>>>>>>>>>>>>>allAssignments",allAssignments);
      console.log(">>>>>>>>>>>>>>>Object.keys(allAssignments).length", Object.keys(allAssignments).length);
    if (allAssignments && Object.keys(allAssignments).length > 0) {
      const characterIds = [
        ...new Set(
          Object.values(allAssignments)
            .map((task) => task.characterId)
            .filter(Boolean)
        ),
      ];

      if (characterIds.length > 0) {
        console.log("Triggering character fetch for IDs:", characterIds);
        fetchCharactersByIds(characterIds);
      } else {
        setCharacters([]);
      }
    }
  }, [allAssignments]); // Re-run when allAssignments updates


  const fetchCharactersByIds = async (characterIds) => {
    console.log("Fetching characters for IDs:", characterIds); // Log before API call
    try {
      const response = await axios.get(`/api/characters`, {
        params: { ids: characterIds.join(",") },
      });
      console.log("API Response:", response.data); // Log API response
      setCharacters(response.data);
    } catch (error) {
      console.error("Error fetching characters:", error);
    }
  };

  useEffect(() => {
    console.log("Updated characters:", characters);
  }, [characters]); // Runs when characters state updates

  useEffect(() => {
    const fetchClass = async () => {
      setLoading(true); // Set loading to true before fetching
      try {
        const response = await axios.get(`/api/classes/${id}`);
        console.log("Classes response:", response);

        setClassItem(response.data);
        // Fetch existing members
        // const membersResponse = await axios.get(`/api/classes/${id}/members`);
        // console.log("Members response:", membersResponse);

        // setExistingMembers(membersResponse.data);
      } catch (error) {
        console.error("Error fetching class:", error);
        message.error("Fehler beim Abrufen der Klasse.");
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    const fetchUsers = async () => {
      TODO: // update this function to only fetch users in the group
      try {
        const response = await axios.get("/api/users"); // Fetch all users
        console.log("Users response:", response);

        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
        message.error("Fehler beim Abrufen der Benutzer.");
      }
    };
    fetchClass();
    fetchUsers();
  }, [id]);

  const fetchActivities = async () => {
    try {
      const response = await axios.get(`/api/classes/${id}/activities`);
      setActivities(response.data || []);
    } catch (error) {
      console.error("Error fetching activities:", error);
      message.error("Fehler beim Abrufen der Aktivitäten.");
    }
  };

  useEffect(() => {
    if (id) {
      fetchActivities();
    }
  }, [id]);


  const updateTasksState = (task_Id) => {
    setAllAssignments((prev) => {
      const updatedAssignments = { ...prev };
      delete updatedAssignments[task_Id]; // Remove the task from state
      return updatedAssignments;
    });
  };


  const activityTreeData = activities.map((activity) => {
    const groups = Array.isArray(activity.groups) ? activity.groups : [];
    return {
      title: activity.title,
      key: `activity-${activity.id}`,
      children: groups.length
        ? groups.map((group) => ({
            title: group.name,
            key: `activity-${activity.id}-group-${group.id}`,
            isLeaf: true,
          }))
        : [
            {
              title: "Keine Gruppen",
              key: `activity-${activity.id}-no-groups`,
              isLeaf: true,
            },
          ],
    };
  });

  const handleTreeSelect = async (selectedKeys, info) => {
    const key = selectedKeys[0];
    if (!key) return;

    const activityOnlyMatch = /^activity-(\d+)$/.exec(key);
    if (activityOnlyMatch) {
      const activityId = Number(activityOnlyMatch[1]);
      setActiveActivityId(activityId);
      setSelectedGroupMembers([]);
      setSelectedGroupActivityId(null);
      setSelectedGroupId(null);
      setSelectedGroupName("");
      return;
    }

    const noGroupsMatch = /^activity-(\d+)-no-groups$/.exec(key);
    if (noGroupsMatch) {
      const activityId = Number(noGroupsMatch[1]);
      setActiveActivityId(activityId);
      setSelectedGroupMembers([]);
      setSelectedGroupActivityId(null);
      setSelectedGroupId(null);
      setSelectedGroupName("");
      return;
    }

    const match = /^activity-(\d+)-group-(\d+)$/.exec(key);
    if (!match) return;

    const activityId = Number(match[1]);
    const groupId = Number(match[2]);
    const groupName = info?.node?.title || "";

    setActiveActivityId(activityId);
    try {
      const response = await axios.get(`/api/groups/${groupId}/members`);
      setSelectedGroupMembers(response.data || []);
      setSelectedGroupActivityId(activityId);
      setSelectedGroupId(groupId);
      setSelectedGroupName(groupName);
    } catch (error) {
      console.error("Error fetching group members:", error);
      message.error("Fehler beim Abrufen der Gruppenmitglieder.");
    }
  };
  const StoryOptionLabel = ({
    text,
    imgSrc,  
    iconStyle,
    fallbackIcon,
  }) => {
    const [imgError, setImgError] = useState(false);
    const hasImg = Boolean(imgSrc) && !imgError;

    useEffect(() => {
      setImgError(false);
    }, [imgSrc]);

    return (
      <Space align="center" size={8} style={{ maxWidth: "100%", display: "flex" }}>
        {hasImg ? (
          <img
            src={imgSrc}
            alt={""}
            style={{
              ...iconStyle,
              display: "block",
              flex: iconStyle?.width ? `0 0 ${iconStyle.width}px` : "0 0 auto",
            }}
            onError={() => setImgError(true)}
          />
        ) : (
          fallbackIcon || (
            <FileImageOutlined
              style={{ fontSize: 20, color: "rgba(0,0,0,0.45)" }}
            />
          )
        )}
        <span
          style={{
            flex: "1 1 auto",
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {text}
        </span>
      </Space>
    );
  };
  return (
    <div style={{ padding: "20px", margin: "0", overflow: "auto" }}>
      <Space direction="vertical" size="large" style={{ width: "100%", marginBottom: "16px" }}>
        <Space size="middle" wrap>
          <Button type="primary" size="large" className="btn" onClick={() => navigate("/classes")}>
            Zurück zu Klassen
          </Button>
          <Button
            icon={<PlusOutlined style={{ fontSize: '24px' }}/>}
            type="primary"
            size="large" className="btn"
            onClick={() => setShowTaskForm(true)}
          >
            Aktivitäten zuweisen
          </Button>
          <Text strong>Klasse: {classItem?.title || "-"}</Text>
          <Text strong>Mitglieder: {classMemberCount}</Text>
        </Space>

        <AddActivity
          visible={showTaskForm}
          onClose={() => {
            setShowTaskForm(false);
            updateTasksState(id);
            fetchActivities();
          }}
          id={id}
          StoryOptionLabel={StoryOptionLabel}
        />

        <Row gutter={[24, 24]}>
          <Col xs={24} lg={6}>
            <Tree
              showLine
              defaultExpandAll
              treeData={activityTreeData}
              onSelect={handleTreeSelect}
            />
          </Col>
          <Col xs={24} lg={18}>
            <Activity
              activities={activities}
              classId={id}
              onGroupsGenerated={fetchActivities}
              selectedGroupMembers={selectedGroupMembers}
              selectedGroupActivityId={selectedGroupActivityId}
              selectedGroupId={selectedGroupId}
              selectedGroupName={selectedGroupName}
              activeActivityId={activeActivityId}
              StoryOptionLabel={StoryOptionLabel}
            />
          </Col>
        </Row>

        {/* <p style={{ margin: 0 }}>Hier kannst du Aufgaben zuweisen.</p> */}
      </Space>

      {/* <Title className="title">{classItem ? classItem.na         me : ""}</Title> */}

      
    </div>
  );
};

export default Klasse;
